import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_COMPANIES_REQUEST = "GET_COMPANIES_REQUEST";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_ERROR = "GET_COMPANIES_ERROR";

//* ACTIONS ------------------------------------------------
export const getCompaniesRequest = (payload = {}, callback) => ({
  type: GET_COMPANIES_REQUEST,
  payload,
  callback,
});

export const getCompaniesSuccess = (data) => ({
  type: GET_COMPANIES_SUCCESS,
  payload: data,
});

export const getCompaniesError = (error) => ({
  type: GET_COMPANIES_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getCompaniesServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/companies`, options);
};
